import { Navigate, Route, Routes } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import { ByVersion, NewShellPage, OldOnly } from './components/VersionRoutes'
import AdminPage from './pages/AdminPage'
import AuditPage from './pages/AuditPage'
import AuthCompletePage from './pages/AuthCompletePage'
import AuthErrorPage from './pages/AuthErrorPage'
import CVGenerationPage from './pages/CVGenerationPage'
import CVHistoryPage from './pages/CVHistoryPage'
import FreeformPage from './pages/FreeformPage'
import HomePage from './pages/HomePage'
import LibraryPage from './pages/LibraryPage'
import LoginPage from './pages/LoginPage'
import OnboardingV2Page from './pages/OnboardingV2Page'
import InvitePage from './pages/InvitePage'
import PrivacyPage from './pages/PrivacyPage'
import SettingsPage from './pages/SettingsPage'
import TermsPage from './pages/TermsPage'
import SmokeTestPage from './pages/SmokeTestPage'

/**
 * Every route in the app. Split from App so tests can render it in a MemoryRouter.
 * Signed-in routes are chosen by users.ui_version (spec f2_ui_version_shell.md §4).
 */
export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/auth/complete" element={<AuthCompletePage />} />
      <Route path="/auth/error" element={<AuthErrorPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/smoke-test" element={<SmokeTestPage />} />

      {/* Protected routes — require authentication */}
      <Route element={<ProtectedRoute />}>
        {/* Both UIs: the old page or the new shell's, by ui_version */}
        <Route path="/home" element={<ByVersion old={<HomePage />} page="home" />} />
        <Route path="/library" element={<ByVersion old={<LibraryPage />} page="library" />} />

        {/* New UI only */}
        <Route path="/applications" element={<NewShellPage page="applications" />} />
        <Route path="/to-review" element={<NewShellPage page="toReview" />} />

        {/* Old UI only */}
        <Route element={<OldOnly />}>
          <Route path="/freeform" element={<FreeformPage />} />
          <Route path="/audit/duplicates" element={<AuditPage />} />
          <Route path="/onboarding" element={<OnboardingV2Page />} />
          <Route path="/onboarding/v2" element={<OnboardingV2Page />} />
          <Route path="/cv/generate" element={<CVGenerationPage />} />
          <Route path="/cv/history" element={<CVHistoryPage />} />
        </Route>

        {/* Both UIs, old design: the new account menu opens Settings until its screens exist */}
        <Route path="/settings" element={<SettingsPage />} />
      </Route>

      {/* Admin route — requires is_admin */}
      <Route element={<ProtectedRoute requireAdmin />}>
        <Route path="/admin" element={<AdminPage />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
